import script from "./NotificacionesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificacionesPanel.vue?vue&type=script&setup=true&lang=js"

import "./NotificacionesPanel.vue?vue&type=style&index=0&id=576a0d2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576a0d2d"]])

export default __exports__